import { GridFilterOperator } from '@mui/x-data-grid-premium'
import { buildFilterOperators } from '@omnea-app/fe-tables/ControlledTable/helpers/buildFilterOperators'
import { SupplierSearchInputFilter } from './SupplierSearchInputFilter'

export const getSupplierSearchFilterOperators = (): GridFilterOperator[] => {
  return buildFilterOperators([
    { operators: ['equals', 'doesNotEqual'], InputComponent: SupplierSearchInputFilter },
    { operators: ['contains', 'doesNotContain'] },
  ])
}
